import React = require("react");
import SvgIcon from "material-ui/SvgIcon";

export class PasteFromWordIcon extends React.Component<__MaterialUI.SvgIconProps, {}> {
    render() {
        /* tslint:disable:max-line-length */
        return (
            <SvgIcon {...this.props}>
                <path d="M5,21.03V4.976H6.97v3H17v-3H18.97V21.03H5ZM12.97,3.99A0.985,0.985,0,1,1,11,3.99,0.985,0.985,0,1,1,12.97,3.99ZM14.8,3A3.142,3.142,0,0,0,13.72,1.549a2.952,2.952,0,0,0-3.469,0A3.131,3.131,0,0,0,9.173,3H5A1.967,1.967,0,0,0,3.6,3.591a1.86,1.86,0,0,0-.61,1.385V21.03a1.858,1.858,0,0,0,.61,1.385A1.964,1.964,0,0,0,5,23H18.97a1.967,1.967,0,0,0,1.406-.587,1.861,1.861,0,0,0,.609-1.385V4.976a1.863,1.863,0,0,0-.609-1.385A1.97,1.97,0,0,0,18.97,3H14.8ZM18,10H16l-1,7-2-7H11L9,17,8,10H6l2,9h2l2-7,2,7h2Z"/>
            </SvgIcon>
        );
        /* tslint:enable:max-line-length */
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/custom-components/svg-icons/PasteFromWord.tsx
 **/